module.exports = __webpack_public_path__ + "static/media/phila_mix.4ba178db.webp";